export const NETWORK_ERROR_MESSAGES_ZH: Record<number, string> = {
  400: "请求参数有误，请稍后重试",
  401: "账户认证失败，请重新登录",
  403: "没有权限执行此操作",
  404: "请求的资源不存在",
  408: "请求超时，请稍后重试",
  429: "请求过于频繁，请稍后重试",
  500: "服务器内部错误，请稍后重试",
  502: "网关错误，请稍后重试",
  503: "服务暂时不可用，请稍后重试",
  504: "网关超时，请稍后重试",
};

export const NETWORK_ERROR_MESSAGES_EN: Record<number, string> = {
  400: "Invalid request, please try again later",
  401: "Authentication failed, please log in again",
  403: "No permission to perform this operation",
  404: "Resource not found",
  408: "Request timed out, please try again later",
  429: "Too many requests, please try again later",
  500: "Internal server error, please try again later",
  502: "Bad gateway, please try again later",
  503: "Service temporarily unavailable, please try again later",
  504: "Gateway timed out, please try again later",
};

export const DEFAULT_NETWORK_ERROR_MESSAGE = {
  zh: "网络请求失败，请稍后重试",
  en: "Network request failed, please try again later",
};

export const DEFAULT_REQUEST_ERROR_MESSAGE = {
  zh: "接口请求失败，请稍后重试",
  en: "Request failed, please try again later",
};

/** SchemaError 专用：接口返回成功（2xx）但前端数据结构校验失败时的友好提示 */
export const SCHEMA_ERROR_MESSAGE = {
  zh: "后端返回数据与 Schema 不符",
  en: "Response schema validation failed",
};

export function hasChinese(text: string): boolean {
  return /[一-龥]/.test(text || "");
}
